import { Center, Loader, Notification, Text, Title } from "@mantine/core";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function EmailConfirmationPage() {
  const [error, setError] = useState<string | null>(null);
  const [isSuccess, setIsSuccess] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Supabase puts the error info in the hash fragment of the URL
    const hash = window.location.hash.substring(1);
    const params = new URLSearchParams(hash);
    const errorCode = params.get("error_code");
    const errorDescription = params.get("error_description");

    if (errorCode || errorDescription) {
      setError(errorDescription || "이메일 인증 중 오류가 발생했습니다. 다시 시도해주세요.");
      setIsSuccess(false);
    } else {
      // If there's no error, it means confirmation was successful.
      // The Supabase client's onAuthStateChange listener should handle the session update.
      // We'll show a success message and redirect to home.
      setIsSuccess(true);
      const timer = setTimeout(() => {
        navigate("/");
      }, 3000); // Redirect after 3 seconds

      return () => clearTimeout(timer); // Cleanup timer on unmount
    }
  }, [navigate]);

  if (error) {
    return (
      <Center h="100vh">
        <Notification color="red" title="Confirmation Failed" withCloseButton={false}>
          {error}
        </Notification>
      </Center>
    );
  }

  if (isSuccess) {
    return (
      <Center h="100vh" style={{ flexDirection: "column", gap: "1rem" }}>
        <Title order={3}>Email Confirmed Successfully!</Title>
        <Text>You will be redirected to the home page shortly.</Text>
        <Loader />
      </Center>
    );
  }

  // Initial state while we're parsing the URL
  return (
    <Center h="100vh">
      <Loader />
    </Center>
  );
}
